import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import type { PermissionCode } from '../lib/permissions'

interface RequirePermissionProps {
  /** Permission code — prefer `PERMS.X` from `lib/permissions` for
   *  compile-time typo catches; plain strings accepted at boundaries
   *  where codes are computed or come from config. */
  permission: PermissionCode | string
  children: React.ReactNode
  /** Override the default /403 redirect target (rare). */
  redirectTo?: string
}

export default function RequirePermission({
  permission,
  children,
  redirectTo = '/403',
}: RequirePermissionProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission)
  const location = useLocation()

  if (!hasPermission(permission)) {
    // Forward the attempted path + required permission into the
    // AccessDenied page so it can show *what* and *why*. Replaces
    // the old silent redirect to /dashboard.
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{
          attemptedPath: location.pathname,
          requiredPermission: permission,
        }}
      />
    )
  }

  return <>{children}</>
}
